import FileConverter from './components/FileConverter.vue';
import analytics from './tools/ga';
import Vue from 'vue';
import LinkAnalyzerView from "./components/LinkAnalyzerView.vue";
import { expBus } from '@js-packages/experiment-loader';
import { isPlaylistResponse } from './tools/playlist';
import { initOpenReplay } from './tools/openreplay';

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

require('./experiment/experimentLoader');

initOpenReplay();

const app = new Vue({
  el: '#app',
  components: {
    LinkAnalyzerView,
    FileConverter,
  },

  data() {
    return {
      getSignedRequestBody: null,
      link: null
    }
  },
  async beforeMount() {
    try {
      this.getSignedRequestBody = await (
        await import(
          /* webpackChunkName: "link.chunk" */
          './tools/getSignedRequestBody.js'
          )
      ).default
    } catch (error) {
      this.getSignedRequestBody = async (requestData) => {
        return typeof requestData === 'string' ? {sf_url: requestData} : requestData;
      }
    }
  },
  mounted() {
    // Default
    // Каналы tzLandingFree:* слушает эксперимент tzLandingFree, имя канала он
    // собирает из parameters.expName — при переименовании эксперимента в конфиге
    // строки ниже надо поменять вместе с ним.
    this.$on('link-submit', (link) => {
      this.link = link
      analytics.linkSubmit(link);
      expBus.emit('clickAds', 'open');
      expBus.emit('tzLandingFree:link', { url: link });
    });
    this.$on('show-results', (data) => {
      analytics.showResults(this.link);
      // Плейлист — не один ролик: лендинг по длительности его первого видео
      // показывать не за что.
      if (!isPlaylistResponse(this.link, data)) {
        expBus.emit('tzLandingFree:result', { url: this.link, data });
      }
    });
    this.$on('show-error', (type) => {
      analytics.showError(this.link, type);
      expBus.emit('tzLandingFree:error', { url: this.link, type });
    });
    this.$on('download-click', (format, eventLabel) => {
      analytics.downloadClick(this.link, format, eventLabel);
      expBus.emit('clickAds', 'open');
      expBus.emit('tzLandingFree:download', { url: this.link, format });
    });

    // Converter
    this.$on('converter-start', () => {
      expBus.emit('clickAds', 'open');
    });
    this.$on('converter-request', () => {
      analytics.converterRequest();
    });
    this.$on('converter-request-success', () => {
      analytics.converterRequestSuccess();
    });
    this.$on('converter-request-failed', () => {
      analytics.converterRequestFailed();
    });
    this.$on('converter-click', (format) => {
      analytics.converterClick(format);
    });
    this.$on('converter-click-all', () => {
      analytics.converterClick();
    });
  },
  methods: {
    async subscribeSignedRequestBody(url) {
      return await this.getSignedRequestBody(
        url
      )
    },
  }
});
